import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { VoucherService } from '../../../services/voucher-service';
import { Voucher } from '../../../models/vouchers/voucher';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '@shared/services/shared.service';
import { AuthService } from '@shared/auth/auth.service';

/*
 * Edit Voucher Dialog
 */
@Component({
  selector: 'voucher-edit',
  templateUrl: 'voucher-edit.html',
  styleUrls: ['./voucher-edit.scss']
})
export class VoucherEditComponent implements OnInit, AfterViewInit {
  @Input('voucherId')
  voucherId: number = 0;
  loading: boolean = false;
  processing: boolean = false;
  voucher: Voucher = null;
  showStatusWarning: boolean = false;
  voucherStatuses: string[] = this.voucherService.voucherStatuses

  voucherForm = new FormGroup({
    applicationStatus: new FormControl('', Validators.required),
    applicantContactName: new FormControl(''),
    applicantAddress: new FormControl(''),
    applicantCity: new FormControl(''),
    applicantState: new FormControl(''),
    applicantZip: new FormControl(''),
    applicantContactPhone: new FormControl(''),
    applicantContactEmail: new FormControl(''),
    voucherMaxValue: new FormControl(''),
    redeemed: new FormControl(false),
    exceedencesDetected: new FormControl(false),
    preferredContactComments: new FormControl(''),
    preferredContactType: new FormControl(''),
    applicantAddressUnit: new FormControl(''),
    treatment: new FormControl(false),
    voucherTreatementMaxValue: new FormControl('')
  });

  constructor(public oregonWellDataService: OregonWellDataService,
    public voucherService: VoucherService,
    public authService: AuthService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private router: Router) {
    this.loading = true;
    let routeId = this.route.snapshot.paramMap.get("id");

    if (routeId != null && routeId != undefined && routeId.length > 0) {
      this.voucherId = Number(this.route.snapshot.paramMap.get("id"));
    }
  }

  ngAfterViewInit(): void {
    this.loadVoucher();
  }

  ngOnInit(): void {
    // ngOnInit
  }

  statusChange() {
    this.showStatusWarning = this.voucherForm.get('applicationStatus').value != this.voucherService.issued && this.voucherForm.get('applicationStatus').value.length > 0;
  }

  loadVoucher() {
    if (this.voucherId <= 0) {
      this.toastr.error("Invalid Voucher");
      return;
    }

    this.loading = true;
    this.voucherService.getVoucherById(this.voucherId).subscribe(
      result => {
        this.voucher = result;
        this.setFormValues();
        this.loading = false;
      },
      error => {
        //this.voucherService.onHttpError(error);
        this.loading = false;
      }
    );
  }

  saveVoucher() {
    if (!this.voucherForm.valid) {
      this.toastr.error("Please fix form validation issues");
      return;
    }

    this.voucher.voucherApplication.applicationStatus = this.voucherForm.get('applicationStatus').value;
    if (this.voucherForm.get('applicationStatus').value == this.voucherService.waitlist) {
      this.sharedService.openConfirm("Are you sure you want to remove this Voucher and put the application back in Waitlist?");
      this.sharedService.confirmed().subscribe(confirmed => {
        if (confirmed) {
          this.processing = true;
          this.voucherService.saveVoucher(this.voucher).subscribe(
            result => {
              this.toastr.success("Voucher " + this.voucher.voucherId + " removed and application updated");
              //redirect to edit voucher application
              this.router.navigate(['vouchers/application/edit/' + this.voucher.voucherApplication.id]);
            },
            error => {
              //this.voucherService.onHttpError(error);
              this.processing = false;
            }
          );
        }
      });
    }
    else {
      this.voucher.applicantContactName = this.voucherForm.get('applicantContactName').value;
      this.voucher.applicantAddress = this.voucherForm.get('applicantAddress').value;
      this.voucher.applicantCity = this.voucherForm.get('applicantCity').value;
      this.voucher.applicantState = this.voucherForm.get('applicantState').value;
      this.voucher.applicantZip = this.voucherForm.get('applicantZip').value;
      this.voucher.applicantContactPhone = this.voucherForm.get('applicantContactPhone').value;
      this.voucher.applicantContactEmail = this.voucherForm.get('applicantContactEmail').value;
      this.voucher.voucherMaxValue = this.voucherForm.get('voucherMaxValue').value;
      this.voucher.voucherTreatementMaxValue = this.voucherForm.get('voucherTreatementMaxValue').value;
      this.voucher.treatment = this.voucherForm.get('treatment').value;
      this.voucher.redeemed = this.voucherForm.get('redeemed').value;
      this.voucher.exceedencesDetected = this.voucherForm.get('exceedencesDetected').value;
      this.voucher.voucherApplication.applicationStatus = this.voucherForm.get('applicationStatus').value;
      this.voucher.preferredContactComments = this.voucherForm.get('preferredContactComments').value;
      this.voucher.preferredContactType = this.voucherForm.get('preferredContactType').value;
      this.voucher.applicantAddressUnit = this.voucherForm.get('applicantAddressUnit').value;

      this.processing = true;

      this.voucherService.saveVoucher(this.voucher).subscribe(
        result => {
          this.loadVoucher();
          this.toastr.success("Voucher " + this.voucher.voucherId + " updated");
          this.processing = false;
        },
        error => {
         // this.voucherService.onHttpError(error);
          this.processing = false;
        }
      );

    }
  }

  setFormValues() {
    this.voucherForm.get('applicantContactName').setValue(this.voucher.applicantContactName);
    this.voucherForm.get('applicantAddress').setValue(this.voucher.applicantAddress);
    this.voucherForm.get('applicantCity').setValue(this.voucher.applicantCity);
    this.voucherForm.get('applicantState').setValue(this.voucher.applicantState);
    this.voucherForm.get('applicantZip').setValue(this.voucher.applicantZip);
    this.voucherForm.get('applicantContactPhone').setValue(this.voucher.applicantContactPhone);
    this.voucherForm.get('applicantContactEmail').setValue(this.voucher.applicantContactEmail);
    this.voucherForm.get('voucherMaxValue').setValue(this.voucher.voucherMaxValue);
    this.voucherForm.get('voucherTreatementMaxValue').setValue(this.voucher.voucherTreatementMaxValue);
    this.voucherForm.get('treatment').setValue(this.voucher.treatment);
    this.voucherForm.get('redeemed').setValue(this.voucher.redeemed);
    this.voucherForm.get('exceedencesDetected').setValue(this.voucher.exceedencesDetected);
    this.voucherForm.get('applicationStatus').setValue(this.voucher.voucherApplication.applicationStatus);
    this.voucherForm.get('preferredContactComments').setValue(this.voucher.preferredContactComments);
    this.voucherForm.get('preferredContactType').setValue(this.voucher.preferredContactType);
    this.voucherForm.get('applicantAddressUnit').setValue(this.voucher.applicantAddressUnit);
  }
}